import Menu from 'choerodon-ui/lib/menu';
export default Menu;
